// Puts the chosen "כמה יחידות תרצי" value into any visible quantity selector linked to the form.
// (form.getAttribute('id'), not form.id: the form has an input named "id" that hides form.id)
function syncUnitsQuantityInputs(form, units) {
  try {
    const formId = form && form.getAttribute('id');
    if (!formId) return;
    document
      .querySelectorAll(`input[name="quantity"][form="${formId}"], #${CSS.escape(formId)} input[name="quantity"]`)
      .forEach((input) => {
        input.value = units;
      });
  } catch (e) {}
}

// When the customer picks a units value, show it in the quantity selector right away.
document.addEventListener('change', (event) => {
  const el = event.target;
  if (!el || !el.name || !el.name.includes('כמה יחידות')) return;
  const units = parseInt(el.value, 10);
  if (!(units > 0)) return;
  const formId = el.getAttribute('form') || (el.closest('form') && el.closest('form').getAttribute('id'));
  if (formId) syncUnitsQuantityInputs(document.getElementById(formId), units);
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.unitsAdded = false;

        // Hide technical properties from checkout: prefix with "_" so Shopify keeps them
        // on the order but does not show them to the customer at checkout.
        const techKey = /^properties\[(color_\d+|choice_\d+|color\d+-title|option\d+-title)(\[\])?\]$/;
        const techEntries = [];
        for (const [key, value] of formData.entries()) {
          if (techKey.test(key)) techEntries.push([key, value]);
        }
        techEntries.forEach(([key]) => formData.delete(key));
        techEntries.forEach(([key, value]) => {
          formData.append(key.replace('properties[', 'properties[_'), value);
        });
        // "כמה יחידות תרצי" -> real cart quantity.
        // The chosen value (1-6) is sent as the line quantity, so variant "2" is added with quantity 2.
        // (Each variant is priced as ONE unit.) Radio buttons are named "<option name>-<position>",
        // dropdowns are named "options[<option name>]", so we match on the option name in either case.
        for (const [key, value] of Array.from(formData.entries())) {
          if (typeof value === 'string' && value && !key.startsWith('properties[') && key.includes('כמה יחידות')) {
            const units = parseInt(value, 10);
            if (units > 0) {
              formData.set('quantity', String(units));
              this.unitsAdded = true;
              syncUnitsQuantityInputs(this.form, units);
            }
            break;
          }
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            // "כמה יחידות": אם המוצר כבר היה בעגלה (למשל 2 ואז 6) — מאחדים לשורה אחת במדרגה הנכונה (8 במחיר של 6)
            if (this.unitsAdded && window.UnitsTier) {
              try {
                const merged = await window.UnitsTier.normalize(this.cart.getSectionsToRender().map((section) => section.id));
                if (merged) {
                  merged.id = response.id;
                  response = merged;
                }
              } catch (e) {
                console.error(e);
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}